import { useQuery } from '@tanstack/react-query';

import CruiseLineService, { type CruiseLine } from '~/services/cruises/CruiseLineService';

export const cruiseLineKeys = {
  all: ['cruiseLines'] as const,
  list: () => [...cruiseLineKeys.all, 'list'] as const,
};

export function useGetCruiseLines() {
  return useQuery<Array<CruiseLine>>({
    queryKey: cruiseLineKeys.list(),
    queryFn: async () => {
      const response = await CruiseLineService.listWithPagination({ take: 200 });
      return response.result;
    },
  });
}
